import ajaxService from "../utils/ajaxServices";
import {
  Categories,
  CompareProducts,
  ProductSearchList,
  ProductSearchtWithoutCategoryList,
} from "../config/queries";
import keysMap from "../config/keysMap";

export const getAllCategories = async (
  isDealPage = false,
  categoryId,
  dealCategoryId
) => {
  const result = await ajaxService.fetchGraphQLGetRequest(Categories, {
    id: categoryId,
  });
  let categories = [];

  if (result && result.category && result.category.children) {
    for (let item of result.category.children) {
      const categoryObj = {
        id: item.id,
        name: item.name,
        short_description: item.short_description,
        imageUrl: item.image && item.image.replace(/www/gi, "shop"),
        activeImageUrl: item.hover_image_url,
        count: item.product_total_count && item.product_total_count,
        position: item.position,
      };
      categoryObj.subCategories = [];
      for (let childrenItem of item.children) {
        const subCategoryObj = {
          id: childrenItem.id,
          name: childrenItem.name,
          short_description: item.short_description,
          imageUrl: childrenItem.image && childrenItem.image.replace(/www/gi, "shop"),
          activeImageUrl: item.hover_image_url,
          count:
            childrenItem.product_total_count &&
            childrenItem.product_total_count,
          position: childrenItem.position,
        };
        categoryObj.subCategories.push(subCategoryObj);
      }
      categories.push(categoryObj);
    }
  }
  if (!isDealPage && categories) {
    const totalCatCount = result?.category?.product_total_count;
    const dealIndex = categories.findIndex(
      (item) => item.id === parseInt(dealCategoryId)
    );
    if (dealIndex !== -1) {
      const totalDealcount = categories[dealIndex].count;
      result.category.product_total_count =
        totalCatCount > 0 ? totalCatCount - totalDealcount : 0;
      categories.splice(dealIndex, 1);
    }
  }
  return {
    categories: categories,
    totalProducts:
      result && result.category && result.category.product_total_count
        ? result.category.product_total_count
        : 0,
    status: result?.status,
    errors: result?.errors,
  };
};

export const getProductCompareList = async (skus) => {
  const result = await ajaxService.fetchGraphQLGetRequest(CompareProducts, {
    skus: skus,
  });
  let compareProductsData = [];
  if (
    result &&
    result.productCompare &&
    result.productCompare.allProducts &&
    result.productCompare.allProducts.length
  ) {
    for (let item of result.productCompare.allProducts) {
      let parsedDataObj = JSON.parse(item.data);
      let compareObj = {};
      Object.entries(parsedDataObj).map(([parentKey, parentValue]) => {
        compareObj[parentKey] = {};
        Object.entries(parentValue).map(([childKey, childValue]) => {
          const _keys = Object.keys(keysMap);
          if (_keys.indexOf(childKey) >= 0) {
            compareObj[parentKey][keysMap[childKey]] = childValue;
          } else {
            compareObj[parentKey][childKey] = childValue;
          }
        });
      });
      compareObj.image = item.image;
      compareObj.name = item.name;
      compareObj.sku = item.sku;
      compareProductsData.push(compareObj);
    }
  } else {
    compareProductsData = [];
  }
  return compareProductsData;
};
export const getProductSearchList = async (key, category_id, signal) => {
  let result;
  if (category_id !== -1) {
    result = await ajaxService.fetchGraphQLGetRequest(
      ProductSearchList,
      {
        key: key,
        id: category_id,
      },
      signal
    );
  } else {
    result = await ajaxService.fetchGraphQLGetRequest(
      ProductSearchtWithoutCategoryList,
      {
        key: key,
      },
      signal
    );
  }

  let searchList = [];
  if (result && result.products && result.products.items) {
    for (const item of result.products.items) {
      const searchItemsObj = {
        name: item.name,
        image: item.small_image,
        sku: item.sku,
        item: item,
      };
      searchList.push(searchItemsObj);
    }
  }
  return searchList;
};
